import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

import { i18n } from "../../translate/i18n";

// confirmColor: cor do botão de confirmar. O padrão "secondary" é o rosa
// default do MUI (o tema não define secondary) — telas novas passam
// "primary" para usar a cor da marca.
//
// cancelColor/cancelVariant: mesmo esquema pro botão de cancelar. O padrão
// segue o cinza contained de sempre, pra nenhuma das ~47 telas que já usam
// este componente mudar de cara sozinha; tela que quiser o cancelar rosa
// vazado passa cancelColor="secondary" cancelVariant="outlined" (mesma
// combinação de Kanban/KanbanCard.js).
const ConfirmationModal = ({
	title,
	children,
	open,
	onClose,
	onConfirm,
	confirmColor = "secondary",
	cancelColor = "default",
	cancelVariant = "contained"
}) => {
	return (
		<Dialog
			open={open}
			onClose={() => onClose(false)}
			aria-labelledby="confirm-dialog"
		>
			<DialogTitle id="confirm-dialog">{title}</DialogTitle>
			<DialogContent dividers>
				<Typography>{children}</Typography>
			</DialogContent>
			<DialogActions>
				<Button
					variant={cancelVariant}
					onClick={() => onClose(false)}
					color={cancelColor}
				>
					{i18n.t("confirmationModal.buttons.cancel")}
				</Button>
				<Button
					variant="contained"
					onClick={() => {
						onClose(false);
						onConfirm();
					}}
					color={confirmColor}
				>
					{i18n.t("confirmationModal.buttons.confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationModal;
